enum Actions {
  // action types
  // INIT_LOAD = "initLoad",
  // HAND_LOAD_STATE = "handLoadState",
  VERIFY_AUTH = "verifyAuth",
  SSO_LOGIN = "ssoLogIn",
  SSO_LOGOUT = "ssoLogOut",
  GET_User = "getUser",
}

enum Mutations {
  // mutation types
  SET_SSO_USER = "setSsoUser",
  SET_USER = "setUser",
}

enum Getters {
  // mutation types
  SSO_USER = "ssoUser",
  API_User = "apiUser",
}

export { Actions, Mutations, Getters };
